import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { CommandButton, Stack } from '@bingads-webui-react/fabric-control';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { ThirdPartyMeasurement, formatThirdPartyMeasurementSetting } from './third-party-measurement';
import { ThirdPartyMeasurementV2 } from './third-party-measurement-V2';


const defaultStyles = {
  thirdPartyMeasurementFolderButton: {
    label: { color: '#0078D4', fontWeight: 600 },
    icon: { fontSize: 14, fontWeight: 400 },
    root: { verticalAlign: 'middle' },
  },
};

export const ThirdPartyMeasurementCardContainer = (props) => {
  const {
    i18n,
    updateValidation,
    validationProps,
    adType = 'video',
    overrideStyles = {},
    showSimpleMessage,
    isForDeal,
    dealLoaded,
    isMOATEnabled,
  } = props;

  const initialFolded = !_.isEmpty(_.get(validationProps, ['data', 'VerifiedTrackingSettings'], {}));
  const [folded, setFolded] = useState(initialFolded);

  const foldedIconProps = useMemo(() => {
    const iconName = folded ? 'ChevronDown' : 'ChevronRight';
    return { iconName };
  }, [folded]);

  const styles = useMemo(() => ({
    ...defaultStyles,
    ...overrideStyles,
  }), [overrideStyles]);

  if (!dealLoaded || isForDeal) return null;

  const ThirdPartyMeasurementComponent = isMOATEnabled ? ThirdPartyMeasurementV2: ThirdPartyMeasurement;

  return (
    <div className="third-party-measurement-tile">
      <Stack verticalAlign="center" horizontal>
        <CommandButton
          className="third-party-measurement-folder-button"
          text={i18n.getString(_TL_('Third-party measurement'))}
          onClick={() => setFolded(!folded)}
          iconProps={foldedIconProps}
          styles={
            styles.thirdPartyMeasurementFolderButton
          }
        />
        <HelpPopupInline topic="pop_BA_VideoAds_Measurement" />
      </Stack>
      {folded ? (
        <ThirdPartyMeasurementComponent
          i18n={i18n}
          updateValidation={updateValidation}
          validationProps={validationProps}
          adType={adType}
          overrideStyles={styles}
        />
      ) : (showSimpleMessage && formatThirdPartyMeasurementSetting(validationProps.data.VerifiedTrackingSettings, i18n))}
    </div>
  );
};

ThirdPartyMeasurementCardContainer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      VerifiedTrackingSettings: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  adType: PropTypes.string,
  showSimpleMessage: PropTypes.bool,
  overrideStyles: PropTypes.shape({}),
  isForDeal: PropTypes.bool,
  dealLoaded: PropTypes.bool,
  isMOATEnabled: PropTypes.bool,
};

ThirdPartyMeasurementCardContainer.defaultProps = {
  adType: 'video',
  showSimpleMessage: false,
  overrideStyles: {},
  isForDeal: false,
  dealLoaded: true,
  isMOATEnabled: false,
};

export const ThirdPartyMeasurementContainerWithValidation = withControlErrorHandling(withUnvalidatedControlErrors(withError(withCustomValidation(ThirdPartyMeasurementCardContainer))));
